import './WhatsonHeader.css';
import React from 'react';
import { canUseDOM, get, getPageThemeColors } from '../../utils';
import RouterLink from '../atoms/RouterLink/RouterLink';
import { Text, Placeholder, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const WhatsonHeader = _ref => {
  let {
    rendering,
    fields,
    children,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const theme = get(sitecoreContext, 'themesOfPage');
  const contexItem = get(fields, 'data.contexItem');
  const pageTitle = get(contexItem, 'title.jss');
  const pageIntro = get(contexItem, 'introText.jss');
  const contextLink = get(contexItem, 'url');
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const themeColor = get(params, 'Color', '');
  const items = get(fields, 'data.whatsOnPage.children') || [];
  const itemsLength = items.filter(item => get(item, 'title.jss.value') && get(item, 'navigationCategory.value.title.jss.value'));
  const whatsOnItemUrl = get(fields, 'data.whatsOnPage.url');
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex', '#fff');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const Color = get(params, 'Color') || '';
  const variables = BackgroundColorHex ? {
    '--m57-whatson-header-color': ColorHex,
    '--m57-whatson-header-primary-color': BackgroundColorHex
  } : {
    '--m57-whatson-header-color': 'var(--main-color-text)',
    '--m57-whatson-header-primary-color': selectedPrimaryColor
  };
  const breadcrumbColor = BackgroundColorHex ? ColorHex : 'var(--main-color-text)';
  const GradientColor = get(params, 'GradientColorHex') || '';
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const {
    filtersAnalytics
  } = fields.data;
  let gradient = null;
  let start = BackgroundColorHex;
  let end = GradientColor;
  if (BackgroundColorHex && BackgroundColorHex.length && GradientColor && GradientColor.length) {
    // @ts-ignore
    start = BackgroundColorHex;
    // @ts-ignore
    end = GradientColor;
    gradient = "w1ygirz3";
  }
  React.useEffect(() => {
    if (GradientColor && GradientColor.length) {
      if (typeof window !== 'undefined') document.querySelector('body').classList.add('colored');
    } else {
      if (typeof window !== 'undefined') document.querySelector('body').classList.remove('colored');
    }
  }, []);
  React.useEffect(() => {
    let style;
    if (breadcrumbColor) {
      style = document.createElement('style');
      style.innerHTML = `:root{--breadcrumb--color: ${breadcrumbColor};}`;
      document.querySelector('head').appendChild(style);
    }
    return () => {
      style && document.querySelector('head').removeChild(style);
    };
  }, [breadcrumbColor]);
  if (!fields) {
    console.warn('WhatsonHeader component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [WhatsonHeader component is empty: please provide data source]");
    }
    return null;
  }
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering
    });
  };
  const renderRouteItems = () => {
    if (items) {
      return items.map((item, index) => {
        const url = get(item, 'url');
        const id = get(item, 'id');
        const title = get(item, 'navigationCategory.value.title.jss.value');
        const titleAnalitics = get(item, 'titleAnalitics.jss.value', '');
        const hasTitle = get(item, 'title.jss.value') && get(item, 'navigationCategory.value.title.jss.value');
        return /*#__PURE__*/React.createElement(React.Fragment, null, url && hasTitle ? /*#__PURE__*/React.createElement("div", {
          key: id,
          className: `g-checkbox__item ${contextLink === url ? 'g-checkbox__item--active' : ''}`,
          "data-id": index
        }, /*#__PURE__*/React.createElement(RouterLink, {
          className: `body-small g-checkbox__label `,
          onClick: () => {
            tealiumClickFunc(tealiumMergeClickData(filtersAnalytics, params), titleAnalitics);
          },
          href: url,
          title: title
        }, title)) : null, ' ');
      });
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    className: GradientColor && gradient && GradientColor.length ? gradient : '',
    rtl: rtl,
    isSharedCh: isSharedCh,
    style: {
      '--startColor': start,
      '--endColor': end
    },
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `header__gt i header__full-width-mob whatson-header`,
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: `header__gti-info-sec  ${!themeColor ? theme ? 'themed-box' : '' : 'themed-box'} ${!themeColor ? theme ? 'colored' : '' : GradientColor && GradientColor.length ? '' : 'has-background'} ${themeColor === 'theme-15' ? 'custom-theme-yellow' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "alignment-with-richtext-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row sm-row-reverse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-9 col-12"
  }, pageTitle && /*#__PURE__*/React.createElement(Text, {
    className: "header__gti-title",
    tag: "h1",
    field: fields.data.contexItem.title.jss
  }), itemsLength.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll"
  }, whatsOnItemUrl ? /*#__PURE__*/React.createElement("div", {
    className: `g-checkbox__item ${contextLink === whatsOnItemUrl ? 'g-checkbox__item--active' : ''}`
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: `body-small g-checkbox__label `,
    href: whatsOnItemUrl,
    title: "All",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(filtersAnalytics, params), 'All');
    }
  }, mapDictionary.get('All'))) : null, renderRouteItems()), pageIntro && /*#__PURE__*/React.createElement(RichText, {
    className: "header__gti-info body-small",
    tag: "div",
    field: fields.data.contexItem.introText.jss
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-3 col-12"
  }, theme && theme.dubai_calendar_logo && /*#__PURE__*/React.createElement("div", {
    className: "header-events__themeLogo"
  }, /*#__PURE__*/React.createElement("img", {
    className: "header-events__title-img",
    src: BASE_URL + theme.dubai_calendar_logo + '?cx=0.5&cy=0.5&cw=150',
    alt: "Logo"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "header-bb__wrapper header-bb__wrapper--poster-show"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder())));
};
const StyledWrapper = _ref2 => {
  let {
    className,
    style = {},
    children,
    rtl,
    anchorUrlParameter,
    isSharedCh
  } = _ref2;
  const commonStyleVar = !isSharedCh ? commonStyles : "c17wqilz";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` ${className ? className : ''} ${commonStyleVar} ${fullWidthStyles} ${rtl ? rtlStyles : ltrStyles} ${headerImageStyle}`,
    style: style
  }, children);
};
export const commonStyles = "c1csrnvy";
export const ltrStyles = "lm91lmu";
export const rtlStyles = "rgmqhj1";
export default WhatsonHeader;